module.exports = __webpack_public_path__ + "files/7bc5cfdbc237e8cd6eacdb7f47518682.png";